import * as jwtDecode from "jwt-decode"

export default class AppTranslationService {
    constructor(private $http, private $q, private $window) {
        'ngInject';
    }


    private getCookie = function(cname) {
        let name = cname + '=';
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }

    private parseJwt = function(token) {
        var decodedToken;

        if (token) {
            try {
                decodedToken = jwtDecode(token);
            } catch(error) {
                //Invalid Token Error: https://github.com/auth0/jwt-decode/blob/master/lib/index.js#L26
            }
        }

        return decodedToken;
    }

    public getBrowserLocale = function() {
        let userLang = navigator.language;

        if (userLang === 'zh') {
            return 'zh_CN';
        }

        return userLang;
    };

    public getJwtLocale = function() {
        var jwt = this.getCookie('gydaToken');
        var decodedJwt = this.parseJwt(jwt);
        var jwtLocale;

        if(decodedJwt && decodedJwt.user) {
            jwtLocale = decodedJwt.user.language;
        }

        return jwtLocale;
    }

    public getUserTranslationData = function() {
        let translationConfig = this.$q.defer();
        let jwtLocale = this.getJwtLocale();
        let translationPath;
        let translationConfigObj = {
            $locale: 'en',
            $translationList: {}
        }

        if (jwtLocale) {
            translationConfigObj.$locale = jwtLocale;
        } else if (this.getBrowserLocale()) {
            translationConfigObj.$locale = this.getBrowserLocale().split('-')[0];
        }

        if (translationConfigObj.$locale === 'us') {
            translationConfigObj.$locale = 'en';
        }

        translationPath = '/data/translations/' + translationConfigObj.$locale + '.json';

        // Version is set on window in webpack.apps.ts
        // Imported from package.json
        // Busts cache on new FHW app releases
        if (this.$window.version) {
            translationPath += `?cb=${this.$window.version}`;
        }

        this.$http.get(translationPath).then(function(res) {
            translationConfigObj.$translationList = res.data;
            translationConfig.resolve(translationConfigObj);
        });

        return translationConfig.promise;
    }
}


/** WEBPACK FOOTER **
 ** ./public/ts/translation/translation.service.ts
 **/